import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { TextBlock } from '../../../components/1elements'

import React, { useState } from 'react'
import GenericMutationModalBase from '../modal/GenericMutationModalBase'

const SelectTypeModal = ({
  entityTypeDisplayName = 'Group Type',
  continuationCallback, // which takes a selectedType
  typeToTypeDisplayName,
  defaultType = 'user',
  listOfTypes,
  isModalOpen,
  setIsModalOpen
}) => {
  const [type, setType] = useState(defaultType)

  const cancelHandler = () => {
    setIsModalOpen(false)
  }

  const saveHandler = () => {
    continuationCallback(type)
    setIsModalOpen(false)
  }

  return (
    <GenericMutationModalBase
      header={`Choose ${entityTypeDisplayName} to continue`}
      saveHandler={saveHandler}
      cancelHandler={cancelHandler}
      open={isModalOpen}
      setOpen={setIsModalOpen}
    >
      <TextBlock heading={'Type: '} required>
        <Select
          id='type'
          name='type'
          value={type}
          onChange={e => {
            setType(e.target.value)
          }}
        >
          {listOfTypes &&
            listOfTypes.map((oneType, index) => (
              <MenuItem value={oneType} key={index}>
                {typeToTypeDisplayName(oneType)}
              </MenuItem>
            ))}
        </Select>
      </TextBlock>
    </GenericMutationModalBase>
  )
}

export default React.memo(SelectTypeModal)
